import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NavigationService } from '../../shared/navigation/navigation.service';
import { MenuItem } from 'primeng/api';
import { TranslationService } from '../../shared';
import { TitleCasePipe } from '../../shared/pipes/titlecase.pipe';

@Component({
  selector: 'wl-dashboard-neo-revenue',
  templateUrl: 'dashboard-neo-revenue.component.html',
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DashboardNeoRevenueComponent implements OnInit {
  public constructor() {}

  ngOnInit() {}
}
